import { OrganizationType } from '../interfaces/organizations';
import { TProduct } from '../server/controllers/products';
import { IFetchProductsPublicParams, IProductsList } from '../server/services/products';

import ProxyClient from './clients/ProxyClient';

export interface IProductsParams {
  tagAlias?: string;
  tag: string;
  id: string;
  type: OrganizationType;
}

export interface IAllProductsParams {
  organizationId: string | number;
  type: OrganizationType;
}

export const loadProductsByTag = async (params: IProductsParams): Promise<TProduct[]> => {
  const { data } = await ProxyClient.get<TProduct[]>('/products', { params });
  return data;
};

export const loadAllProducts = async (params: IAllProductsParams) => {
  const { data } = await ProxyClient.get('/productsAll', { params });
  return data;
};

export const loadEducationProductsList = async (params: IFetchProductsPublicParams) => {
  const { data } = await ProxyClient.post<IProductsList>('/products/education', params);
  return data;
};
